import React, { useMemo, useRef } from 'react';
import { EditorStarterItem } from '../../items/item-type';
import { useItemDrag } from '../utils/drag/use-timeline-item-drag';
import { cn } from '@crabs-ai/ds-react';

export const TIMELINE_ITEM_BORDER_WIDTH = 1;

export function TimelineItemContainer({
  children,
  isSelected,
  item,
  isLocked = false,
}: {
  children: React.ReactNode;
  isSelected: boolean;
  item: EditorStarterItem;
  isLocked?: boolean;
}) {
  const timelineItemRef = useRef<HTMLDivElement>(null);

  const { onPointerDown, onClick } = useItemDrag({
    draggedItem: item,
    isLocked,
  });

  const style = useMemo(() => {
    return {
      borderWidth: TIMELINE_ITEM_BORDER_WIDTH,
      // borderColor: 'var(--color-sys-bg-surface)',
    };
  }, []);

  return (
    <div
      ref={timelineItemRef}
      tabIndex={isLocked ? undefined : -1}
      onPointerDown={onPointerDown}
      onClick={onClick}
      className={cn(
        'absolute box-border h-full w-full overflow-hidden rounded-3xs select-none',
        isLocked ? 'cursor-not-allowed' : 'cursor-pointer',
        isSelected && 'border-[1.5px]! border-sys-style-neutral-ultradark!',
      )}
      style={style}
    >
      {children}
      {isLocked && (
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundImage: `repeating-linear-gradient(
              135deg,
              transparent,
              transparent 4px,
              var(--sys-cont-inverse-light) 4px,
              var(--sys-cont-inverse-light) 8px
            )`,
            opacity: 0.3,
          }}
        />
      )}
    </div>
  );
}
